import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-3xl max-sm:heading-2xl !font-[450]',
    header: 'mb-8 max-md:mb-6 max-sm:flex max-sm:justify-between max-sm:gap-3',
    mobileCloseButton: '-mt-2 hidden size-10 p-0 max-sm:block',
    closeIcon: 'size-8',
    form: '',
    closeButton: '!top-[30px] !right-[30px] max-sm:hidden',
    content: 'py-6 max-md:px-3 max-md:py-6 sm:w-[640px] sm:px-10 sm:py-10'
  }
});
